import React from "react";
import { Check, ArrowRight, MessageCircle } from "lucide-react";
import { Section, Reveal, BrutalButton, useLead } from "./shared";
import { FINAL_LIST, LINKS } from "../../lib/site";

export default function FinalClose() {
  const { openLead } = useLead();
  return (
    <Section id="final" bg="bg-brand-black" dark>
      <Reveal className="max-w-4xl">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-yellow">One Year From Now</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-6xl leading-[1.02] mt-4 text-brand-cream">
          One Year From Now, You Could Still Be Asking:
        </h2>
        <p className="font-serif-e italic text-2xl sm:text-3xl lg:text-4xl mt-5 text-brand-red">
          &ldquo;What Should I Make My Next Video About?&rdquo;
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <p className="text-brand-cream/60 uppercase tracking-widest text-xs font-bold mt-14">Or you could have:</p>
        <div className="grid sm:grid-cols-2 gap-x-8 gap-y-3 mt-5 max-w-3xl">
          {FINAL_LIST.map((f) => (
            <div key={f} className="flex items-center gap-3">
              <span className="h-6 w-6 rounded-full bg-brand-green flex items-center justify-center shrink-0"><Check size={13} className="text-white" /></span>
              <span className="text-brand-cream text-sm sm:text-base">{f}</span>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-tight mt-16 max-w-4xl text-brand-cream">
          You Do Not Need <span className="text-brand-red">Everyone</span> to Watch Your Videos. You Need the <span className="text-brand-green">Right People</span> to Discover You, Trust You, and Take the Next Step.
        </h3>

        <div className="mt-10 flex flex-col sm:flex-row gap-3">
          <BrutalButton onClick={openLead} variant="yellow" data-testid="final-join-button">
            Join YouTube Lead Generation Mastery <ArrowRight size={18} />
          </BrutalButton>
          <BrutalButton href={LINKS.whatsapp} variant="green" data-testid="final-whatsapp-button">
            <MessageCircle size={18} /> Talk to Ratish on WhatsApp
          </BrutalButton>
        </div>
      </Reveal>
    </Section>
  );
}
